module.exports = __webpack_public_path__ + "static/media/react.7520bee1.svg";